import React from "react";
import { Box, Container, Text, SimpleGrid, Flex } from "@chakra-ui/react";
import { motion } from "framer-motion";
import { X } from "lucide-react";

const MotionBox = motion(Box);

const notHereItems = [
  "Random, unstructured notes",
  "Content without context",
  "Practice without explanation",
  "Time spent without direction",
];

export const Positioning = () => {
  return (
    <Box bg="#FFFFFF" py={{ base: "64px", md: "80px" }}>
      <Container maxW="1200px" px={{ base: "5", md: "8" }}>

        <Flex direction="column" align="center" textAlign="center" mb={{ base: 10, md: 14 }}>
          <Text
            fontFamily="'Inter', sans-serif"
            fontSize="0.8125rem"
            fontWeight="600"
            letterSpacing="0.1em"
            textTransform="uppercase"
            color="rgba(41,52,82,0.45)"
            mb={3}
          >
            Our Standards
          </Text>
          <Text
            as="h2"
            fontFamily="'Public Sans', sans-serif"
            fontWeight="600"
            fontSize={{ base: "1.75rem", md: "2.375rem" }}
            color="#293452"
            lineHeight="1.25"
          >
            What you won't find here
          </Text>
        </Flex>

        <SimpleGrid columns={{ base: 1, sm: 2 }} spacing={4} maxW="720px" mx="auto">
          {notHereItems.map((item, i) => (
            <MotionBox
              key={item}
              initial={{ opacity: 0, y: 16 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.4, delay: i * 0.08 }}
            >
              <Flex
                align="center"
                gap={4}
                p={5}
                bg="#fafafa"
                borderRadius="12px"
                border="1px solid #f1f5f9"
                h="full"
                _hover={{ borderColor: "#fee2e2", bg: "#fff5f5" }}
                transition="all 0.2s"
              >
                <Box
                  w="36px"
                  h="36px"
                  borderRadius="10px"
                  bg="#fee2e2"
                  display="flex"
                  alignItems="center"
                  justifyContent="center"
                  flexShrink={0}
                >
                  <X size={16} color="#dc2626" strokeWidth={2.5} />
                </Box>
                <Text
                  fontFamily="'Inter', sans-serif"
                  fontSize="0.9375rem"
                  color="#94a3b8"
                  textDecoration="line-through"
                  textDecorationColor="#cbd5e1"
                >
                  {item}
                </Text>
              </Flex>
            </MotionBox>
          ))}
        </SimpleGrid>

      </Container>
    </Box>
  );
};
